import { parse } from 'yaml';
import { FileNotFoundGitError } from '../errors/file-not-found.git-error';
import { UnprocessableJSONGitError } from '../errors/unprocessable-json.git-error';
import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';
import { _FSReadFileActionFn } from './fs-read-file';

export interface FSReadYAMLAction extends WorkerAction {
  type: FSAction.ReadYAML;
  params: { path: string; cwd?: string };
}

export async function FSReadYAMLActionFn<T = unknown>(params: WorkerFnParams<FSReadYAMLAction>): Promise<T | null> {
  const {
    util,
    params: { path },
  } = params;

  if (!util.itemExistsAt(path)) {
    throw new FileNotFoundGitError(path);
  }

  try {
    const fileContent = await _FSReadFileActionFn(params);
    return fileContent ? parse(fileContent) : null;
  } catch (err) {
    throw new UnprocessableJSONGitError(path);
  }
}
